import { InfoCircleOutlined } from '@ant-design/icons';
import { Form, Input } from 'antd';
import React from 'react'

const TextAreaUC = (props) => {
    const { TextArea } = Input;
    const {
        name,
        label,
        tooltipTitle = null,
        tooltipPlacement = 'topLeft',
        onChange,
        values,
        maxLength,
        placeholder,
        required,
        disabled,
        row,
        showLabel = true,
        ...prop
    } = props;

    return (
        <>
            <Form.Item
                label={showLabel ? label : ''}
                name={name}
                initialValue={values ? values : ''}
                rules={required ? [{ required: true, message: 'กรุณากรอก ' + label }] : ''}
                tooltip={tooltipTitle ? {
                    title: tooltipTitle,
                    icon: <InfoCircleOutlined />,
                    placement: tooltipPlacement,
                    className: "label-Tooltip color-information"
                } : null}
            >
                <TextArea
                    placeholder={placeholder ? placeholder : ''}
                    rows={row ? row : 3}
                    maxLength={maxLength ? maxLength : 500}
                    disabled={disabled}
                    onChange={onChange}
                    onKeyPress={(ev) => {
                        if (ev.key === "Enter") {
                            ev.preventDefault();
                            console.log(ev.target.value);
                        }
                    }}
                    {...prop} />
            </Form.Item>
        </>
    )
}

export default TextAreaUC